import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <h4>The Code Icon</h4>
            <p>The Code Icon helps global companies scale engineering teams through staff augmentation and dedicated developers.</p>
          </div>
          <div className="footer-section">
            <h4>Services</h4>
            <ul>
              <li><Link to="/services">Frontend Developers</Link></li>
              <li><Link to="/services">Backend Developers</Link></li>
              <li><Link to="/services">Full Stack Developers</Link></li>
              <li><Link to="/services">Mobile App Developers</Link></li>
              <li><Link to="/services">QA & Automation</Link></li>
              <li><Link to="/services">DevOps & Cloud</Link></li>
            </ul>
          </div>
          <div className="footer-section">
            <h4>Company</h4>
            <ul>
              <li><Link to="/how-it-works">How It Works</Link></li>
              <li><Link to="/case-studies">Case Studies</Link></li>
              <li><Link to="/calculator">Team Cost Calculator</Link></li>
              <li><Link to="/contact">Contact Us</Link></li>
            </ul>
          </div>
          <div className="footer-section">
            <h4>Contact</h4>
            <ul>
              <li>Email: admin@thecodeicon.com</li>
              {/* <li>Phone: +1 (555) 123-4567</li> */}
              <li>Location: Farah Heights Gulberg Block 10 FB Area. Karachi, Pakistan.</li>
            </ul>
          </div>
        </div>
        <div className="footer-bottom">
          <p>&copy; 2025 The Code Icon. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
